import React from 'react';
import cn from 'classnames';

import { OkIcon } from '@/icons';

import styles from './service-card.module.scss';

interface IProps {
  id: number;
  text: string;
  isLast?: boolean;
  className?: string;
}

const ServiceCard: React.FC<IProps> = (props) => {
  const { className, id, text, isLast } = props;

  return (
    <div className={cn(styles.card, className)}>
      {isLast ? (
        <span className={styles.card__circle_icon}>
          <OkIcon className={styles.card__circleOk} />
        </span>
      ) : (
        <span className={styles.card__circle}>{id}</span>
      )}
      <p className={styles.card__text}>{text}</p>
    </div>
  );
};

export default ServiceCard;
